const CIRCUIT_TYPE_NORMAL = "NormalCircuit";
const CIRCUIT_TYPE_MAIN = "MainCircuit";
const CIRCUIT_TYPE_END = "EndCircuit";

const CIRCUIT_TYPES = {
  NORMAL: CIRCUIT_TYPE_NORMAL,
  MAIN: CIRCUIT_TYPE_MAIN,
  END: CIRCUIT_TYPE_END
};

const CIRCUIT_TYPE_LABELS = {
  [CIRCUIT_TYPE_NORMAL]: "Normal Circuit",
  [CIRCUIT_TYPE_MAIN]: "Main Circuit",
  [CIRCUIT_TYPE_END]: "End Circuit"
};

export default { CIRCUIT_TYPES, CIRCUIT_TYPE_LABELS };
export { CIRCUIT_TYPES, CIRCUIT_TYPE_LABELS };
